import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExtendedWarningYellow = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 29,
	viewBox: "0 0 30 29",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M1.9375 25.1875L15 2.625L28.0625 25.1875H1.9375ZM15 21.625C15.3365 21.625 15.6185 21.5112 15.8461 21.2836C16.0737 21.056 16.1875 20.774 16.1875 20.4375C16.1875 20.101 16.0737 19.819 15.8461 19.5914C15.6185 19.3638 15.3365 19.25 15 19.25C14.6635 19.25 14.3815 19.3638 14.1539 19.5914C13.9263 19.819 13.8125 20.101 13.8125 20.4375C13.8125 20.774 13.9263 21.056 14.1539 21.2836C14.3815 21.5112 14.6635 21.625 15 21.625ZM13.8125 18.0625H16.1875V12.125H13.8125V18.0625Z",
		fill: "url(#paint0_linear_18511_7420)"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_18511_7420",
		x1: 1.80003,
		y1: 25.4844,
		x2: 29.7792,
		y2: 4.42637,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", { stopColor: "#FFA51F" }),
			/* @__PURE__ */ _jsx("stop", {
				offset: .5,
				stopColor: "#FFA51F"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FFF3DF"
			})
		]
	}) })]
});
export default SvgExtendedWarningYellow;
